import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import FormatAddress from "go-core/components/Formatters/FormatAddress";
import {
	FormatDate,
	FormatTime,
	defaultMinuteFormatTime,
	exactlySameDay,
	formatStringToDate,
} from "go-core/components/Formatters/FormatDate";
import { OrderContext } from "../../../../contexts/OrderContext";

const OrderInfoDelivery = () => {
	const { order } = useContext(OrderContext);
	const { t } = useTranslation();

	if (!order || !order.delivery) return <></>;

	const { delivery_at, address } = order.delivery;
	const hasAddressValue = address && Object.values(address).filter((value) => value).length > 0;
	const showEstimatedDeliveryTime = delivery_at && !order.preparation_status_changes?.delivered_at;

	const isDeliveryAtToday = exactlySameDay(new Date(), delivery_at ? formatStringToDate(delivery_at) : undefined);

	return (
		<div>
			{hasAddressValue && (
				<div className={`w-100 text-center ${showEstimatedDeliveryTime ? "mb-2" : "mb-0"}`}>
					<small className="text-muted">{`${t("modules.e_order.field.delivery_address.title")}:`}</small>
					<p className="mb-0 text-muted font-weight-bold">{<FormatAddress address={address} />}</p>
				</div>
			)}
			{showEstimatedDeliveryTime && (
				<div className="w-100 text-center">
					<small className="text-muted">{`${t(
						"modules.e_order.field.estimated_delivery_time.title"
					)}:`}</small>
					<p className="mb-0 font-weight-bold text-primary delivery-at-title">
						{isDeliveryAtToday
							? FormatTime(delivery_at, undefined, defaultMinuteFormatTime)
							: FormatDate(delivery_at)}
					</p>
				</div>
			)}
		</div>
	);
};

export default OrderInfoDelivery;
